import * as React from 'react';

import styles from './SectionHeader.module.scss';
import SectionTitle from '../molecules/SectionTitle';
import BackgroundText from '../atoms/BackgroundText';

interface Props {
  title_en: string;
  title_jp: string;
}

const SectionHeader = (props: Props) => (
  <div className={styles.SectionHeader}>
    <BackgroundText title_en={props.title_en} />
    <SectionTitle title_jp={props.title_jp} />
  </div>
);

export default SectionHeader;
